module.exports = __webpack_public_path__ + "img/profile-cover-860-200.09a39297.png";